import { useMemo } from 'react'
import { useDevGateStore } from '../stores/useDevGateStore'
import { useUnifiedPanelStore } from '../stores/useUnifiedPanelStore'
import { useKeyboardShortcuts, ShortcutDef } from './useKeyboardShortcuts'

export function useDevModeShortcuts() {
  const { isOpen, togglePanel, closePanel } = useUnifiedPanelStore()
  const { isUnlocked } = useDevGateStore()

  const shortcuts = useMemo<ShortcutDef[]>(() => {
    const defs: ShortcutDef[] = [
      // Ctrl+Y - toggle unified dev panel
      { key: 'y', ctrl: true, handler: togglePanel },
    ]
    // Escape - close panel (only when open)
    if (isOpen) {
      defs.push({ key: 'Escape', handler: closePanel })
    }
    return defs
  }, [isOpen, togglePanel, closePanel])

  useKeyboardShortcuts(shortcuts, isUnlocked)
}
